import { useState, useCallback } from 'react';
import { useTracking } from 'react-tracking';

import { Modal, Text, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

import { StyledButton, StyledList } from './styled';

export const MoreInformationModal = () => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'moreInformation',
  });

  const open = useCallback(() => {
    trackEvent({ action: 'openModal' });
    setIsOpen(true);
  }, [trackEvent]);

  const close = useCallback(() => {
    trackEvent({ action: 'closeModal' });
    setIsOpen(false);
  }, [trackEvent]);

  return (
    <Track>
      <StyledButton
        onClick={open}
        styleType="passive"
        aria-label="Open more info modal"
      >
        <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
      </StyledButton>
      {isOpen ? (
        <Modal
          title="Snowflake Analysis & Key Metrics"
          fullscreen
          primaryLabel="Close"
          onClose={close}
          onPrimaryClick={close}
        >
          <StyledList as="ul" gap="4px">
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  The Snowflake
                </Text>{' '}
                is a visual summary of our company analysis based on five
                fundamental areas: Value, Future, Past, Health and Dividend. It
                gives you an instant snapshot of company's investment profile,
                helping you quickly decide if it is worth researching any
                further.
              </Text>
            </li>
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  Market Cap
                </Text>{' '}
                refers to how much a company is worth. It is defined as the
                total market value of all outstanding shares. Market cap is
                often used to determine a company's size, then evaluate the
                company's financial performance to other companies of various
                sizes.
              </Text>
            </li>
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  Price to Earnings (PE) ratio
                </Text>
                , which measures how much investors are paying for today's
                earnings. A high PE ratio may indicate that investors are
                expecting high growth in the future. This is calculated by
                dividing the share price by earnings per share.
              </Text>
            </li>
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  E. Growth or Sales Growth
                </Text>{' '}
                refers to the 1 to 3 year forecasted annual earnings growth or
                sales growth based on consensus analyst expectations.
              </Text>
            </li>
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  Div. Yield
                </Text>{' '}
                refers to the current dividend yield paid by the company.
              </Text>
            </li>
            <li>
              <Text typography="xSmall" color="spaceGray">
                <Text typography="xSmallStrong" as="span">
                  1Y price target
                </Text>{' '}
                is the forecasted price in one year time based on consensus
                analyst expectations.
              </Text>
            </li>
          </StyledList>
        </Modal>
      ) : null}
    </Track>
  );
};
